export const UB_BOTTOM_RIGHT_POPUP_COLLAPSED = "brpCollapsed"
export const UB_BOTTOM_RIGHT_POPUP_INTRO_ANIMATION_DONE = "brpIntroAnimationDone"

export namespace BottomRightPopupCookieValue {
  export function isBottomRightPopupCollapsed(cookieVal: string | undefined): boolean {
    if (!cookieVal) {
      return false
    } else {
      return "true" === cookieVal
    }
  }
  export function wasBottomRightPopupIntroAnimationDone(cookieVal: string | undefined): boolean {
    if (!cookieVal) {
      return false
    } else {
      return "true" === cookieVal
    }
  }
}
